(function ($) {

    window.EnsembleVideo = window.EnsembleVideo || {};

    /*
    Parameters:
        options
        - The plugin configuraiton
    Description:
        Plugin constructor
    */
    window.EnsembleVideo.ListOrGridPlugin = function (options) {
        this.requestId = options.requestId;
        this.institutionId = options.institutionId;

        this.filter = options.filter;

        this.api = options.api;
        this.setting = options.setting;
        this.localization = options.localization;

        this.contentQueryString = options.contentQueryString;
        this.resourceLinkQueryString = options.resourceLinkQueryString;

        this.refreshIdentity = options.refreshIdentity;
        this.identityQueryString = options.identityQueryString;

        this.identityParams = {};
        this.identityRefreshInterval = 0;     

        this.isResponsive = PlaylistUtility.stringToBool(options.isResponsive);
        this.adjustHeight = PlaylistUtility.stringToBool(options.adjustHeight); 
        this.forceIframe = PlaylistUtility.stringToBool(options.forceIframe);
        this.isPreview = PlaylistUtility.stringToBool(options.isPreview);
        this.view = options.defaultView;        

        this.hal = null;
        this.playlist = null;

        this.currentPlaybackItem = null;

        this.gridRow = null;
        this.gridCounter = 0;
        this.lastItemIndex = 0;

        this.loaderIdSelector = '#loading_spinner_' + this.requestId;
        this.moreLoaderIdSelector = '#loading_spinner_more_' + this.requestId;
        this.pluginSelector = '#pl_plugin_' + this.requestId;
        this.pluginPlayerSelector = '#pl_plugin_player_' + this.requestId;
        this.pluginPreviewSelector = '#pl-plugin-preview_' + this.requestId;
        this.itemsCollectionSelector = '#pl_collection_' + this.requestId;
        this.itemsContainerSelector = '#pl_items_container_' + this.requestId;
        this.itemsCountSelector = '#pl_items_count_' + this.requestId;
        this.categoriesBlockSelector = '#pl_categories_block_' + this.requestId;
        this.categoriesSelector = '#pl_categories_' + this.requestId;
        this.searchSelector = '#pl_search_' + this.requestId;
        this.searchBtnSelector = '#pl_search_btn_' + this.requestId;
        this.listViewSelector = '#pl_list_view_' + this.requestId;
        this.gridViewSelector = '#pl_grid_view_' + this.requestId;
        this.iframePlayerTemplateSelector = '#pl_tmpl_iframe_player_' + this.requestId;
        this.javascriptPlayerTemplateSelector = '#pl_tmpl_javascript_player_' + this.requestId;
        this.headerBlocksSelector = '.ev-pl-header-info_' + this.requestId + ', .ev-pl-header-filter_' + this.requestId;
        this.headerSelector = '.ev-pl-header_' + this.requestId;
        this.emptySelector = '#pl_empty_' + this.requestId;
        this.listItemTemplateSelector = '#pl_tmpl_list_item_' + this.requestId;
        this.listItemImgSelector = '.ev-pl-list-item-img_' + this.requestId;
        this.listItemDescSelector = '.ev-pl-list-item-desc_' + this.requestId;
        this.embedContainerSelector = '#' + options.embedContainerId;
        this.logoSelector = '#pl-header-logo-' + this.requestId;
        this.launchSelector = '.ev-pl-launch-' + this.requestId;

        this.closeOverlayBtnSelector = '#pl_overlay_close_btn_' + this.requestId;
        this.previousItemBtnSelector = '#pl_overlay_previous_btn_' + this.requestId;
        this.nextItemBtnSelector = '#pl_overlay_next_btn_' + this.requestId;

        this.gridItemTemplateSelector = '#pl_tmpl_grid_item_' + this.requestId;
        this.gridItemImgSelector = '.ev-pl-grid-item-img_' + this.requestId;

        this.gridItemsSelector = '.ev-pl-grid-item_' + this.requestId;
        this.listItemsSelector = '.ev-pl-list-item_' + this.requestId;
        this.gridItemOverlaySelector = '.ev-pl-grid-item-info-overlay-' + this.requestId;
        this.gridItemLaunchSelector = '.ev-pl-link-launch';

        this.playableItemsSelector = '.ev-pl-list-play_' + this.requestId + ', .ev-pl-grid-play_' + this.requestId;
        this.loadableItemsTemplateSelector = '.ev-pl-list-play_' + this.requestId + '[data-index={data-index}], .ev-pl-grid-play_' +
            this.requestId + '[data-index={data-index}]';
        this.clearItemsSelector = '.ev-pl-list-item_' + this.requestId + ', .ev-pl-grid-item_' + this.requestId + ', .ev-pl-grid-row_' + this.requestId;
        
        this.loadMoreLoaderSelector = '.ev-pl-loader_' + this.requestId;
        this.clickRegisteredSelector = '.click-registered' + this.requestId;

        this.listPlayClass = 'ev-pl-list-play_' + this.requestId;
        this.gridPlayClass = 'ev-pl-grid-play_' + this.requestId;

        this.clickRegisteredClass = 'click-registered' + this.requestId;

        this.gridItemResponsiveClass = 'ev-pl-item-3';

        this.listItemImgResponsiveClass = 'ev-pl-item-3';
        this.listItemDescResponsiveClass = 'ev-pl-item-9';

        this.headerBlockResponsiveClass = 'ev-pl-item-6';

        this.headerHeight = 109;

        this.thumbnailWidth = 0;
        this.thumbnailHeight = 0;

        this.viewPreferenceStorageKey = "ev.preference.playlist.view";
    };

    window.EnsembleVideo.ListOrGridPlugin.prototype = {
        /*
        Description:
            Initializes plugin
        */
        initialize: function () {
            $(this.loaderIdSelector).css('display', 'table');

            if (!this.isPreview) {
                this.view = PlaylistUtility.getStoragePreference({
                    key: this.viewPreferenceStorageKey,
                    defaultValue: this.view
                });
            }       

            this.hal = new window.EnsembleVideo.Hal({
                rootUrl: this.api.rootUrl,
                setting: this.setting,
                institutionId: this.institutionId
            });
            this.handleIdentityRefresh();

            var $this = this;            
            this.hal.initialize(function() {
                $this.hal.get($this.api.playlistUrl, $this.filter, function (data) {
                    $this.playlist = $this.parseData(data);
                    if ($this.playlist.itemsCount === 0) {                        
                        $this.renderEmptyPlaylist();
                        return;
                    }

                    $this.handleHeaderResize();
                    $this.renderHeader();
                    $this.handlePlayerResize();
                    $this.adjustPluginHeight();
                    $this.render();
                    $this.handleInitialActions();
                });
            });
        },
        handleIdentityRefresh: function () {
            if (!this.refreshIdentity || this.identityQueryString === undefined ||
                this.identityQueryString === null || this.identityQueryString === "")
                return;

            this.identityRefreshInterval = PlaylistUtility.getIdentityRefreshInterval(this.identityQueryString);
            if (this.identityRefreshInterval === 0)
                return;

            var $this = this;
            setTimeout(function () {
                var identityUrl = PlaylistUtility.appendCustomQuery($this.api.pluginIdentityUrl, $this.identityQueryString);
                console.log('Refreshing Identity: ' + $this.identityQueryString);
                $this.hal.get(identityUrl, {}, function (data) {
                    $this.identityQueryString = data.identityQuery;
                    $this.identityParams = {
                        "idn_playlist": data.playlistId,
                        "idn_content": data.contentId,
                        "idn_dropbox": data.dropboxId,
                        "idn_ref": data.ref,
                        "idn_pp": data.playlistPa,
                        "idn_cp": data.contentPa,
                        "idn_dp": data.dropboxPa,
                        "idn_ua": data.ua,
                        "idn_pe": data.isPe,
                        "idn_init": data.isInit,
                        "idn_expiry": data.expiry,
                        "idn_ri": data.refreshInterval,
                        "idn_sig": data.signature
                    };

                    $this.handleIdentityRefresh();
                }, function (request, error) {
                    location.reload(true);
                });
            }, this.identityRefreshInterval);
        },
        parseData: function (data) {
            if (data === null || data === undefined)
                return null;

            var playlist = {
                name: this.hal.parseHalObject(data, this.hal.playlistNamePath, ""),
                logo: this.hal.parseHalObject(data, this.hal.playlistLogoPath, undefined),
                items: [],
                itemsCount: data.totalItemsCount,
                categories: this.hal.parseHalObject(data, this.hal.playlistPublishedCategoriesPath, []),
                nextPageUrl: this.hal.parseHalObject(data, this.hal.nextPagePath, undefined)
            };

            var $this = this;
            $.each(data._embedded.publishing,
                function (index, publish) {
                    playlist.items.push($this.hal.parsePublish(publish));
                });

            return playlist;
        },
        parsePageData: function (data) {
            if (data === null || data === undefined)
                return null;

            var playlist = {
                items: [],
                nextPageUrl: this.hal.parseHalObject(data, this.hal.nextPagePath, undefined)
            };

            var $this = this;
            $.each(data._embedded.publishing,
                function (index, publish) {
                    playlist.items.push($this.hal.parsePublish(publish));
                });

            return playlist;
        },
        renderEmptyPlaylist: function () {
            $(this.loaderIdSelector).css('display', 'none');
            $(this.emptySelector).show();
        },
        render: function () {            
            if (this.view === 'list') {
                this.renderList(this.playlist.items);
                this.handleListResize();

                $(this.loaderIdSelector).css('display', 'none');
                $(this.logoSelector).show();
            } else {
                this.renderGrid(this.playlist.items);
                this.handleGridResize();

                $(this.loaderIdSelector).css('display', 'none');
                $(this.logoSelector).show();

                var $itemsCollection = $(this.itemsCollectionSelector);
                while ($itemsCollection.children().height() < $itemsCollection.outerHeight() && this.hasNextPage()) {
                    this.loadMore($itemsCollection);
                }
            }
        },
        renderMore: function($items) {
            if (this.view === 'list') {
                this.renderList($items);
                this.handleListResize();
            } else {
                this.renderGrid($items);
                this.handleGridResize();
            }
        },
        renderList: function ($items) {
            var $this = this;
            
            $.each($items, function (index, publish) {
                var currentIndex = $this.lastItemIndex + 1;

                var pluginUrl = PlaylistUtility.appendCustomQuery(publish.pluginUrl, $this.contentQueryString);
                pluginUrl = PlaylistUtility.appendCustomQuery(pluginUrl, $this.identityQueryString);
                pluginUrl = PlaylistUtility.appendCustomQuery(pluginUrl, $this.resourceLinkQueryString);

                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "autoPlay", "true");
                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "displayMetaData", "true");
                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "displayTitle", "true");

                var javascriptPluginUrl = PlaylistUtility.appendCustomQuery(publish.javascriptPluginUrl, $this.contentQueryString);
                javascriptPluginUrl = PlaylistUtility.appendCustomQuery(javascriptPluginUrl, $this.identityQueryString);
                javascriptPluginUrl = PlaylistUtility.appendCustomQuery(javascriptPluginUrl, $this.resourceLinkQueryString);

                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "autoPlay", "true");
                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "displayMetaData", "true");
                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "displayTitle", "true");

                var $itemObj = $($this.listItemTemplateSelector).tmpl({
                    index: currentIndex,
                    id: publish.id,
                    isQuiz: publish.isQuiz,
                    name: publish.name,
                    duration: publish.duration,
                    pluginUrl: pluginUrl,
                    javascriptPluginUrl: javascriptPluginUrl,
                    launchUrl: PlaylistUtility.setLaunchUrl(publish.launchUrl, $this.contentQueryString, $this.identityQueryString, $this.resourceLinkQueryString),
                    viewsCount: publish.viewsCount,
                    dateProduced: publish.dateProduced,
                    thumbnailUrl: PlaylistUtility.setThumbnailParameters(publish.thumbnailUrl, 300, 169, "Black"),
                    isYoutube: publish.isYoutube
                });

                $($this.itemsContainerSelector).append($itemObj);

                $this.lastItemIndex = currentIndex;
            });

            this.handleItemsActions();
            this.setScrollerHeight();
        },
        renderGrid: function ($items) {
            var $this = this;
            
            $.each($items, function (index, publish) {
                var currentIndex = $this.lastItemIndex + 1;

                var pluginUrl = PlaylistUtility.appendCustomQuery(publish.pluginUrl, $this.contentQueryString);
                pluginUrl = PlaylistUtility.appendCustomQuery(pluginUrl, $this.identityQueryString);
                pluginUrl = PlaylistUtility.appendCustomQuery(pluginUrl, $this.resourceLinkQueryString);

                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "autoPlay", "true");
                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "displayMetaData", "true");
                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "displayTitle", "true");
                pluginUrl = PlaylistUtility.overrideParameter(pluginUrl, "displayMenu", "true");

                var javascriptPluginUrl = PlaylistUtility.appendCustomQuery(publish.javascriptPluginUrl, $this.contentQueryString);
                javascriptPluginUrl = PlaylistUtility.appendCustomQuery(javascriptPluginUrl, $this.identityQueryString);
                javascriptPluginUrl = PlaylistUtility.appendCustomQuery(javascriptPluginUrl, $this.resourceLinkQueryString);

                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "autoPlay", "true");
                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "displayMetaData", "true");
                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "displayTitle", "true");
                javascriptPluginUrl = PlaylistUtility.overrideParameter(javascriptPluginUrl, "displayMenu", "true");

                var $itemObj = $($this.gridItemTemplateSelector).tmpl({
                    index: currentIndex,
                    id: publish.id,
                    isQuiz: publish.isQuiz,
                    name: publish.name,
                    duration: publish.duration,
                    pluginUrl: pluginUrl,
                    javascriptPluginUrl: javascriptPluginUrl,
                    launchUrl: PlaylistUtility.setLaunchUrl(publish.launchUrl, $this.contentQueryString, $this.identityQueryString, $this.resourceLinkQueryString),
                    viewsCount: publish.viewsCount,
                    dateProduced: publish.dateProduced,
                    thumbnailUrl: PlaylistUtility.setThumbnailParameters(publish.thumbnailUrl, 300, 169, "Black"),
                    isYoutube: publish.isYoutube
                });

                $($this.itemsContainerSelector).append($itemObj);

                $this.lastItemIndex = currentIndex;
            });

            this.handleItemsActions();
            this.setScrollerHeight();
        },
        renderHeader: function () {
            this.renderVideosCount();
            this.renderSearch();
            this.renderCategories();
        },
        renderVideosCount: function () {
            var itemsLocalization = (this.playlist.itemsCount > 1) ? this.localization.videos : this.localization.video;
            $(this.itemsCountSelector).text(this.playlist.itemsCount + ' ' + itemsLocalization);
        },
        renderSearch: function() {
            if (this.search !== null && this.search !== undefined)
                $(this.searchSelector).val(this.search);
        },
        renderCategories: function () {
            if (this.playlist.categories.length < 2)
                return;

            var $categoriesSelect = $(this.categoriesSelector);

            $categoriesSelect.empty().append($('<option value="-1">' + this.localization.viewAll + '</option>'));
            $.each(this.playlist.categories, function (index, category) {
                var $option = $('<option></option>');
                $option.attr('value', category.id).text(category.name);
                $categoriesSelect.append($option);
            });

            $(this.categoriesBlockSelector).removeClass('ev-hidden');
        },
        handleInitialActions: function () {
            var $this = this;
            
            $(this.gridViewSelector).on('click', function () {
                if ($this.view === 'grid')
                    return;

                $this.view = 'grid';
                if (!$this.isPreview) {
                    PlaylistUtility.setStoragePreference({
                        key: $this.viewPreferenceStorageKey,
                        value: 'grid'
                    });
                }               

                $this.lastItemIndex = 0;

                $($this.clearItemsSelector).remove();

                $this.renderGrid($this.playlist.items);
                $this.handleGridResize();

                var $itemsCollection = $($this.itemsCollectionSelector);
                while ($itemsCollection.children().height() - 200 < $itemsCollection.outerHeight() && $this.hasNextPage()) {
                    $this.loadMore($itemsCollection);
                }
            });

            $(this.listViewSelector).on('click', function () {
                if ($this.view === 'list')
                    return;

                $this.view = 'list';
                if (!$this.isPreview) {
                    PlaylistUtility.setStoragePreference({
                        key: $this.viewPreferenceStorageKey,
                        value: 'list'
                    });
                }                

                $this.lastItemIndex = 0;

                $($this.clearItemsSelector).remove();

                $this.renderList($this.playlist.items);
                $this.handleListResize();
            });

            $(this.searchBtnSelector).on('click', function () {
                $($this.clearItemsSelector).remove();
                $this.refresh();
            });

            $(this.searchSelector).on('keyup', function (e) {
                if (e.which === 13) {
                    $($this.searchBtnSelector).click();
                }
            });
            
            $(this.categoriesSelector).on('change', function () {
                $($this.clearItemsSelector).remove();
                $this.refresh();
            });

            $(this.itemsCollectionSelector).on('scroll', function () {
                var $itemsCollection = $(this);
                if (Math.abs($itemsCollection[0].scrollHeight - $itemsCollection.scrollTop() - $itemsCollection.outerHeight()) < 1) {
                    $this.loadMore($itemsCollection);
                }
            });

            $(this.closeOverlayBtnSelector).on('click', function () {
                $($this.pluginPlayerSelector).empty();
                $($this.pluginPreviewSelector).hide();
            });

            $(this.previousItemBtnSelector).on('click', function () {
                $this.loadPreviousPlayerItem();
            });

            $(this.nextItemBtnSelector).on('click', function () {
                $this.loadNextPlayerItem();
            });

            if (this.isResponsive) {
                $(window).on('resize', function () {
                    $this.handleGridResize();
                    $this.handleListResize();
                    $this.handlePlayerResize();
                    $this.handleHeaderResize();
                    $this.setScrollerHeight();
                    $this.adjustPluginHeight();
                });
            }
        },
        handleGridResize: function () {
            if (this.view !== 'grid')
                return;

            var $gridItems = $(this.gridItemsSelector);
            var currentGridResponsiveClass = this.gridItemResponsiveClass;

            this.setGridResponsiveClass();
            $gridItems.removeClass(currentGridResponsiveClass)
                .addClass(this.gridItemResponsiveClass);

            $gridItems.find(this.gridItemImgSelector).css('width', this.thumbnailWidth + 'px').css('height', this.thumbnailHeight + 'px');
            $gridItems.css('height', this.thumbnailHeight + 'px');
        },
        handleListResize: function () {
            if (this.view !== 'list')
                return;

            var $listItems = $(this.listItemsSelector);
            var currentListImgResponsiveClass = this.listItemImgResponsiveClass;
            var currentListDescResponsiveClass = this.listItemDescResponsiveClass;

            this.setListResponsiveClass();
            $listItems.find(this.listItemImgSelector).removeClass(currentListImgResponsiveClass).addClass(this.listItemImgResponsiveClass)
                .css('width', this.thumbnailWidth + 'px').css('height', this.thumbnailHeight + 'px');
            $listItems.find(this.listItemDescSelector).removeClass(currentListDescResponsiveClass).addClass(this.listItemDescResponsiveClass);
        },
        handleHeaderResize: function() {
            var $headerBlocks = $(this.headerBlocksSelector);
            var currentResponsiveClass = this.headerBlockResponsiveClass;

            this.setHeaderResponsiveClass();
            $headerBlocks.removeClass(currentResponsiveClass)
                .addClass(this.headerBlockResponsiveClass);

            $(this.headerSelector).css('display', 'block');
        },
        handlePlayerResize: function () {
            var $plugin = $(this.pluginSelector);
            var $player = $(this.pluginPlayerSelector);
            var playerWidth = ($plugin.width() * 0.5625) + 40;
            $player.css('height', playerWidth + 'px');
        },
        adjustPluginHeight: function () {
            if (!this.adjustHeight)
                return;          
            
            var pluginWidth = $(this.pluginSelector).width();

            var embedHeight = 0;
            if (pluginWidth >= 400) {
                embedHeight = pluginWidth * 0.5625 + 140;
            } else {
                embedHeight = pluginWidth * 0.5625 + 390;
            }
            $(this.embedContainerSelector).css('height', embedHeight + 10 + 'px');
        },
        handleItemsActions: function() {     
            var $collection = $(this.playableItemsSelector).not(this.clickRegisteredSelector);
            var $collectionMainWrapper = $collection.parent().parent();

            var $this = this;
            $collection.on('click', function (e) {
                e.preventDefault();

                $this.currentPlaybackItem = $(this);
                $this.loadPlayer($this.currentPlaybackItem);
            });           

            $collectionMainWrapper.find($this.launchSelector).on('click', function (e) {
                e.preventDefault();

                var launchUrl = PlaylistUtility.overrideIdentityParams($(this).attr('href'), $this.identityParams);
                window.open(launchUrl, "_blank");
            });

            $collection.find('img').on('error', function (e) {
                var fallbackThumbnail = PlaylistUtility.setThumbnailParameters($this.hal.fallbackThumbnailUrl, 300, 169, "Black");
                var $img = $(this);
                if ($img.attr('src') !== fallbackThumbnail) {
                    $img.attr('src', fallbackThumbnail);
                    $img.off('error');
                }
            });

            // Accessibility handling
            $collection.on('focus', function (e) {                
                var $item = $(this);
                $(window).keyup(function (e) {
                    var code = (e.keyCode ? e.keyCode : e.which);
                    if (code === 9 && $item.is(':focus')) {
                        $item.parent().parent().find($this.gridItemOverlaySelector).addClass('focus');
                    }
                });
            });
            
            $collectionMainWrapper.find(this.gridItemLaunchSelector).on('focus', function (e) {
                $(this).parent().parent().parent().addClass('focus');
            });

            $collectionMainWrapper.find(this.gridItemLaunchSelector).on('blur', function (e) {
                $(this).parent().parent().parent().removeClass('focus');
            });

            $collection.addClass($this.clickRegisteredClass);
        },
        loadMore: function ($itemsCollection) {
            if (!this.hasNextPage())
                return;                           

            var nextPageUrl = this.playlist.nextPageUrl;
            nextPageUrl = PlaylistUtility.appendCustomQuery(nextPageUrl, this.identityQueryString);
            this.playlist.nextPageUrl = null;

            var isMainLoaderVisible = $(this.loaderIdSelector).is(':visible');
            if (!isMainLoaderVisible)
                $($itemsCollection).find(this.loadMoreLoaderSelector).show();

            var $this = this;
            $this.hal.get(nextPageUrl, {}, function (data) {
                var pagePlaylist = $this.parsePageData(data);

                $this.playlist.nextPageUrl = pagePlaylist.nextPageUrl;
                $.each(pagePlaylist.items, function (index, item) {
                    $this.playlist.items.push(item);
                });

                $this.renderMore(pagePlaylist.items);

                if (!isMainLoaderVisible)
                    $($itemsCollection).find($this.loadMoreLoaderSelector).hide();
            });
        },
        refresh: function () {     
            this.filter.search = $(this.searchSelector).val();
            this.filter.categories = ($(this.categoriesSelector).val() === '-1') ? undefined : $(this.categoriesSelector).val();

            this.gridCounter = 0;
            this.lastItemIndex = 0;

            var $itemsCollection = $(this.itemsCollectionSelector);            
            $itemsCollection.find(this.clearItemsSelector).remove();
            $itemsCollection.css('height', 'initial');

            $(this.loaderIdSelector).css('display', 'table');

            var $this = this;
            var playlistUrl = PlaylistUtility.overrideIdentityParams($this.api.playlistUrl, $this.identityParams);
            $this.hal.get(playlistUrl, $this.filter, function (data) {
                $this.playlist = $this.parseData(data);

                $this.renderVideosCount();
                $this.render();                
            });
        },
        loadPlayer: function ($item) {
            var name = $item.attr('data-name');
            var $itemEmbed = '';

            if (PlaylistUtility.insideIframe() || this.forceIframe || $item.attr('data-is-youtube') === 'true') {
                var pluginUrl = $item.attr('data-plugin-url');
                $itemEmbed = $(this.iframePlayerTemplateSelector).tmpl({
                    name: name,
                    pluginUrl: PlaylistUtility.overrideIdentityParams(pluginUrl, this.identityParams)
                });
            } else {
                var id = $item.attr('data-id');
                var embedId = 'embed_' + this.requestId + '_' + id;
                var javascriptPluginUrl = PlaylistUtility.overrideParameter($item.attr('data-plugin-javascript-url'), 'embedId', embedId);
                javascriptPluginUrl = PlaylistUtility.overrideIdentityParams(javascriptPluginUrl, this.identityParams);
                var innerScript = '<script type="text/javascript" src="' + javascriptPluginUrl + '"></script>';
                $itemEmbed = $(this.javascriptPlayerTemplateSelector).tmpl({
                    id: id,
                    name: name,
                    embedId: embedId,
                    innerScript: innerScript
                });
            }

            $(this.pluginPlayerSelector).html($itemEmbed.html());

            $(this.previousItemBtnSelector).removeClass('disabled').removeAttr('disabled');
            $(this.nextItemBtnSelector).removeClass('disabled').removeAttr('disabled');

            if ($item.attr('data-index') === "1") {
                $(this.previousItemBtnSelector).addClass('disabled').attr('disabled', 'disabled');
            } 
            if ($item.attr('data-index') === this.playlist.itemsCount.toString()) {
                $(this.nextItemBtnSelector).addClass('disabled').attr('disabled', 'disabled');
            } 

            var $pluginPreview = $(this.pluginPreviewSelector);
            if (!$pluginPreview.is(':visible')) {
                $pluginPreview.show();
                $pluginPreview.find(this.closeOverlayBtnSelector).focus();
            }            
        },
        loadNextPlayerItem: function() {
            var currentIndex = parseInt(this.currentPlaybackItem.attr('data-index'));
            this.currentPlaybackItem = $(this.loadableItemsTemplateSelector.replace(/{data-index}/g, currentIndex + 1));
            
            this.loadPlayer(this.currentPlaybackItem);
        },
        loadPreviousPlayerItem: function () {
            var currentIndex = parseInt(this.currentPlaybackItem.attr('data-index'));
            this.currentPlaybackItem = $(this.loadableItemsTemplateSelector.replace(/{data-index}/g, currentIndex - 1));

            this.loadPlayer(this.currentPlaybackItem);
        },
        setGridResponsiveClass: function() {
            var itemsContainerWidth = $(this.itemsContainerSelector).width();
            if (itemsContainerWidth >= 800) {
                this.gridItemResponsiveClass = "ev-pl-item-3";

                this.thumbnailWidth = (itemsContainerWidth * 25 / 100) - 30;
                this.thumbnailHeight = this.thumbnailWidth * 0.5625;

                return;
            }
            if (itemsContainerWidth >= 650) {
                this.gridItemResponsiveClass = "ev-pl-item-4";

                this.thumbnailWidth = (itemsContainerWidth * 33.3 / 100) - 30;
                this.thumbnailHeight = this.thumbnailWidth * 0.5625;

                return;
            }
            if (itemsContainerWidth >= 400) {
                this.gridItemResponsiveClass = "ev-pl-item-6";

                this.thumbnailWidth = (itemsContainerWidth * 50 / 100) - 30;
                this.thumbnailHeight = this.thumbnailWidth * 0.5625;

                return;
            }

            this.gridItemResponsiveClass = "ev-pl-item-12";

            this.thumbnailWidth = itemsContainerWidth - 30;
            this.thumbnailHeight = this.thumbnailWidth * 0.5625;
        },
        setListResponsiveClass: function () {
            var itemsContainerWidth = $(this.itemsContainerSelector).width();
            if (itemsContainerWidth >= 300) {
                this.listItemImgResponsiveClass = "ev-pl-item-3";
                this.listItemDescResponsiveClass = "ev-pl-item-9";

                this.thumbnailWidth = (itemsContainerWidth * 25) / 100;
                this.thumbnailHeight = this.thumbnailWidth * 0.5625;
                return;
            }

            this.listItemImgResponsiveClass = "ev-pl-item-12";
            this.listItemDescResponsiveClass = "ev-pl-item-12";

            this.thumbnailWidth = itemsContainerWidth;
            this.thumbnailHeight = this.thumbnailWidth * 0.5625;
        },
        setHeaderResponsiveClass: function () {
            var itemsContainerWidth = $(this.itemsContainerSelector).width();
            if (itemsContainerWidth >= 500) {
                this.headerBlockResponsiveClass = "ev-pl-item-6";
                return;
            }

            this.headerBlockResponsiveClass = "ev-pl-item-12";
        },
        setScrollerHeight: function () {
            this.headerHeight = $(this.headerSelector).height() + 26;
            $(this.itemsCollectionSelector).css('height', 'calc(100% - ' + this.headerHeight + 'px)');
        },
        hasNextPage: function () {
            return this.playlist.nextPageUrl !== undefined &&
                this.playlist.nextPageUrl !== null &&
                this.playlist.nextPageUrl !== "";
        }
    };
})(jQuery);